import { render, staticRenderFns } from "./IFrameForm.vue?vue&type=template&id=10c5e9a2&scoped=true"
import script from "./IFrameForm.vue?vue&type=script&lang=js"
export * from "./IFrameForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5e9a2",
  null
  
)

export default component.exports